import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["link", "previos", "next", "last", "finalize"];

  connect(){
    // make first link active
    this.makeActive(this.firstElement)
    this.currentPage = 1
    this.updateButtonsDisable();
  }

  toggle(event){
    this.makeActive(event.target)
    this.currentPage = this.pageFromLinks()
    this.updateButtonsDisable()
  }

  // get current page due to active link
  pageFromLinks(){
    let index = this.linkTargets.findIndex(element=> element.parentElement && element.parentElement.classList.contains('bulk-show-link-active'))

    if (index > 0){
      return index + 1
    }else{
      return 1
    }
  }

  cleanActiveElements(){
    this.linkTargets.forEach(element=>{
      element.parentElement && element.parentElement.classList.remove('bulk-show-link-active')
    })
  }

  makeActive(target){
    this.cleanActiveElements()

    target.parentElement && target.parentElement.classList.add('bulk-show-link-active')
  }

  get firstElement(){
    return this.linkTargets[0]
  }

  get lastElement(){
    return this.linkTargets[this.linkTargets.length - 1]
  }

  // Pagination
  handleNext(e){
    if(this.currentPage < this.linkTargets.length){
      this.currentPage++
      this.changePage()
      let currentElement = this.linkTargets[this.currentPage -1]
      this.makeActive(currentElement)
      e.target.href = currentElement.href
    }
  }

  handlePrevios(e){
    if(this.currentPage > 1){
      this.currentPage--
      this.changePage()
      let currentElement = this.linkTargets[this.currentPage -1]
      this.makeActive(currentElement)
      e.target.href = currentElement.href
    }
  }

  handleLast(e){
    this.currentPage = this.linkTargets.length
    this.makeActive(this.lastElement)
    this.updateButtonsDisable()

    e.target.href = this.lastElement.href
  }

  changePage(){
    if(this.currentPage < 1) this.changePage = 1
    if(this.currentPage > this.linkTargets.length) this.currentPage = this.linkTargets.length

    this.updateButtonsDisable()
  }

  updateButtonsDisable(){
    this.previosTarget.classList.remove('disabled')
    this.nextTarget.classList.remove('disabled')
    this.lastTarget.classList.remove('disabled')
    this.finalizeTarget.classList.add('d-none')

    if(this.currentPage == 1){
      this.previosTarget.classList.add('disabled');
    }

    if(this.currentPage == this.linkTargets.length){
      this.nextTarget.classList.add('disabled')
      this.lastTarget.classList.add('disabled')
      this.finalizeTarget.classList.remove('d-none')
    }
  }
}